import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StudentProgramsComponent } from './student-programs/student-programs.component';
import { HistoryComponent } from './history/history.component';

const routes: Routes = [
  { path: 'estudiante-programas', component: StudentProgramsComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentsRoutingModule { }
